<div class="text-700 text-center">
    <div class="text-blue-600 font-bold mb-3"><i class="pi pi-heart"></i>&nbsp;¡ Hola {{currentUser.firstname }} ! </div>
    <div class="text-900 font-bold text-7xl mb-3">Bienvenido a {{appConfig.app.name}}</div>
    <div class="text-700 text-2xl mb-5">Aún hay que completar algunos detalles y luego a facturar muy fácil.</div>
    <p-listbox  [options]="assistant.items"  optionLabel="name" optionDisabled="complete || true"
                [(ngModel)]="itemAssistant"
                [ngModelOptions]="{standalone: true}"
                [multiple]="false" [checkbox]="false" 
                [metaKeySelection]="false"
                (onClick)="irAAssistentOpcion($event)"
                (onDblClick)="irAAssistentOpcion($event)"
                emptyMessage="{{ appConfig.ux.emptyMsg }}"
                [listStyle]="{'max-height':'500px'}"
                class="p-listbox-assistant">
        <ng-template let-item pTemplate="item">
            <div class="w-full text-left"
                 [pTooltip]="'Clic para completar '+ item.name.toLowerCase()" tooltipPosition="bottom"
                 style="display: contents;">
                <i class="{{item.complete ? 'pi pi-check-circle text-green-600 text-6xl' : 'pi pi-arrow-right text-pink-600 text-6xl'}}"></i>
                <span class="ml-1">
                    {{item.name}}
                    <strong>{{item.description}}</strong>
                </span>
            </div>
        </ng-template>
    </p-listbox>
    <button 
        pButton
        pRipple
        type="button"
        label="Nueva factura"
        size="xlarge"
        icon="pi pi-send"
        class="font-bold px-5 py-3 p-button-raised p-button-rounded white-space-nowrap p-button-lg"
        (click)="irAInicio()" 
        [disabled]="!assistant.complete">
    </button>
</div>